<template>

	<div class="ph_register">

		<!-- Wizard with validation -->
		<div class="card">
			<div class="card-header bg-white header-elements-inline">
				<h6 class="card-title">Formulaire d'adhésion à la coopérative</h6>
				<div class="header-elements">
					<div class="list-icons">
						<img src="/logos/logo-ospharm.png" class="img-fluid" width="80" height="80" alt="">
					</div>
				</div>
			</div>

			<form class="wizard-form steps-validation" action="#" data-fouc>
				<h6>Accueil</h6>
				<fieldset>

				<div class="row">
					<div class="col-6">
						<img src="/assets/images/welcome.svg" alt="" style="margin-top: 50px;">
					</div>
					<div class="col-6 blue">
						<div style="height:80px; margin-bottom:10px;">
							<img src="/assets/images/ospharm-cooperative.png" alt="" style="margin-top: 10px; width: 200px;">
						</div>
						<p class="justify">
							Afin d'améliorer votre expérience utilisateur sur le site Biogran Pro,
							la coopérative Ospharm vous propose de devenir votre <strong>tiers de confiance</strong>
							dans la gestion de vos <strong>données statistiques</strong>.
						</p>
						<p class="justify">
							Forte de ses <strong>8500 pharmaciens coopérateurs</strong>, Ospharm est la première coopérative de pharmaciens.
							Notre mission est de proposer des <strong>services innovants</strong>, à haut valeur ajoutée, pour assurer <strong>l'avenir de l'officine</strong>.
						</p>
						<p class="justify">
							Notre plateforme Ospharm Datastat vous permet d'avoir la pleine <strong>maitrise du partage de vos informations</strong>.
							A tout moment vous pouvez consulter la liste des personnes avec qui vous partagez des données, en ajouter, ou en supprimer.
						</p>
					</div>
				</div>

				</fieldset>

				<h6>Pharmacie</h6>
				<fieldset>

					<div class="row">
						<div class="col-md-12">
							<div class="form-group row">
								<label class="col-form-label col-lg-4">Numéro national de la Pharmacie (CIP)<br/>2055196:</label>
								<div class="col-lg-8">
									<input type="text" id="pharma_cip" name="cip" data-mask="9999999" class="form-control" placeholder="Entrez le CIP de votre pharmacie">
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<div class="form-group row">
								<label class="col-form-label col-lg-4">{{name}} Raison sociale de la Pharmacie :</label>
								<div class="col-lg-8">
									<input type="text" class="form-control requiredz" name="name" placeholder="Raison sociale">
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">

							<div class="form-group row">
								<label class="col-lg-4 col-form-label">Adresse complète :</label>
								<div class="col-lg-8">
									<div class="row">
										<div class="col-md-12">
											<input type="text" name="streetAddressLine1" placeholder="Rue" class="form-control mb-3">
										</div>
									</div>
									<div class="row">
										<div class="col-md-6">
											<input type="text" name="postalCode" placeholder="Code postal" class="form-control mb-3">
										</div>
										<div class="col-md-6">
											<input type="text" name="cityName" placeholder="Ville" class="form-control mb-3">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Appartenez-vous à un groupement<span class="text-danger">*</span> :</label>
								<div class="row" style="margin-top:10px;">
									<div class="col">
										<div class="form-check">
											<label class="form-check-label">
												<input type="radio" name="group" value="1" class="form-input-styled" data-fouc>
												Oui
											</label>
										</div>
									</div>
									<div class="col">
										<div class="form-check">
											<label class="form-check-label">
												<input type="radio" name="group" value="0" class="form-input-styled" data-fouc>
												Non
											</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Si oui, quel est le groupement ?</label>
								<input type="text" class="form-control requiredz" placeholder="Nom du groupement">
							</div>
						</div>
					</div>

				</fieldset>

				<h6>Contact</h6>
				<fieldset>
					<div class="row">
						<div class="col-md-12">
							<div class="form-group row">
								<label class="col-lg-2 col-form-label">Nom du titulaire : </label>
								<div class="col-lg-10">
									<div class="row">
										<div class="col-md-4">
											<select name="location" data-placeholder="Civilité" class="form-control form-control-select2" data-fouc>
												<option></option>
												<option value="Madame">Madame</option>
												<option value="Mademoiselle">Mademoiselle</option>
												<option value="Monsieur">Monsieur</option>
												<option value="Monsieur et Madame">Monsieur et Madame</option>
												<option value="Messieurs">Messieurs</option>
												<option value="Mesdames">Mesdames</option>
											</select>
										</div>
										<div class="col-md-4">
											<input type="text" name="prenom" placeholder="Prénom" class="form-control">
										</div>
										<div class="col-md-4">
											<input type="text" name="nom" placeholder="Nom" class="form-control">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<div class="form-group row">
								<label class="col-lg-2 col-form-label">Coordonnées : </label>
								<div class="col-lg-10">
									<div class="row">
										<div class="col-md-4">
											<input type="text" name="phone" placeholder="Téléphone fixe" class="form-control">
										</div>
										<div class="col-md-4">
											<input type="text" name="mobile" placeholder="Téléphone mobile" class="form-control">
										</div>
										<div class="col-md-4">
											<input type="text" name="fax" placeholder="Fax" class="form-control">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<div class="form-group row">
								<label class="col-lg-2 col-form-label">Adresse email<span class="text-danger">*</span>: </label>
								<div class="col-lg-10">
									<input type="text" name="email" placeholder="Email" class="form-control mb-1">
									<span style="color: grey; font-size: 12px;">Afin de vous transmettre vos statistiques</span>
								</div>
							</div>
						</div>
					</div>

				</fieldset>

				<h6>Logiciel</h6>
				<fieldset>

					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>Société éditrice de votre <strong>L</strong>ogiciel de <strong>G</strong>estion d'<strong>O</strong>fficine: </label>
								<input type="text" name="lgo_company" placeholder="Nom de la société" class="form-control mb-1">
							</div>
						</div>
					</div>


					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Nom du logiciel: <span class="text-danger">*</span></label>
								<input type="text" name="lgo_name" placeholder="Nom du logiciel" class="form-control">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Version: </label>
								<input type="text" name="lgo_version" placeholder="Version" class="form-control">
							</div>
						</div>
					</div>

				</fieldset>

				<h6>Environnement</h6>
				<fieldset>
					<div class="row" style="margin-bottom: 15px;">
						<div class="col-md-12">
							Les renseignements collectés ci-dessous le sont uniquement à destination des fichiers OSPHARM, et serviront à l'établissement de statistiques comparatives de votre officine. A aucun moment du processus, une information nominative concernant votre officine ne sera transmise à des tiers.
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Situation de votre officine:<span class="text-danger">*</span></label>
								<select name="situation" data-placeholder="Choisir une option..." class="form-control form-control-select2 requiredz" data-fouc>
									<option></option>
									<option value="Banlieue">Banlieue</option>
									<option value="Centre Ville">Centre Ville</option>
									<option value="Centre commercial">Centre commercial</option>
									<option value="Quartier">Quartier</option>
									<option value="Rurale">Rurale</option>
									<option value="Saisonnière Mer">Saisonnière Mer</option>
									<option value="Saisonnière Montagne">Saisonnière Montagne</option>
								</select>
							</div>
						</div>

						<div class="col-md-6">
							<div class="form-group">
								<label>Superficie de la surface client en libre service:<span class="text-danger">*</span></label>
								<select name="superficy" data-placeholder="Choisir une option..." class="form-control form-control-select2 requiredz" data-fouc>
									<option></option>
					    		<option value="Moins de 30 m²">Moins de 30 m²</option>
					    		<option value="De 30 à 49 m²">De 30 à 49 m²</option>
					    		<option value="De 50 à 69 m²">De 50 à 69 m²</option>
					    		<option value="De 70 à 149 m²">De 70 à 149 m²</option>
					    		<option value="Plus de 150 m²">Plus de 150 m²</option>
								</select>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Tranche de CA TTC:<span class="text-danger">*</span></label>
								<select name="ca" data-placeholder="Choisir une option..." class="form-control form-control-select2 requiredz" data-fouc>
									<option></option>
					    		<option value="Moins de 460 K€">Moins de 460 K€</option>
					    		<option value="De 460 K€ à moins de 915 K€">De 460 K€ à moins de 915 K€</option>
					    		<option value="De 915  K€ à moins de 1 372  K€">De 915  K€ à moins de 1 372  K€</option>
					    		<option value="De 1 372  K€ à moins de 1 830  K€">De 1 372  K€ à moins de 1 830  K€</option>
					    		<option value="De 1 830  K€ à moins de 2 287  K€">De 1 830  K€ à moins de 2 287  K€</option>
					    		<option value="De 2 287  K€ à moins de 3 049  K€">De 2 287  K€ à moins de 3 049  K€</option>
					    		<option value="De 3 049 K€ à moins de 4 574 K€">De 3 049 K€ à moins de 4 574 K€</option>
					    		<option value="Plus de 4 574  K€">Plus de 4 574  K€</option>
								</select>
							</div>
						</div>

						<div class="col-md-6">
							<div class="form-group">
								<label>Moyenne de clients / jour:<span class="text-danger">*</span></label>
								<select name="client" data-placeholder="Choisir une option..." class="form-control form-control-select2 requiredz" data-fouc>
									<option></option>
					    		<option value="Moins de 50">Moins de 50</option>
					    		<option value="De 50 à 100">De 50 à 100</option>
					    		<option value="De 101 à 250">De 101 à 250</option>
					    		<option value="De 251 à 400">De 251 à 400</option>
					    		<option value="Plus de 400">Plus de 400</option>
								</select>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>Tranche d'effectifs sur la base de 35h hebdomadaire, y compris le ou les titulaires si salarié(s):<span class="text-danger">*</span></label>
								<select name="source" data-placeholder="Choisir une option..." class="form-control form-control-select2 requiredz" data-fouc>
									<option></option>
					    		<option value="Moins de 4 salariés">Moins de 4 salariés</option>
					    		<option value="De 4 à 5 salariés">De 4 à 5 salariés</option>
					    		<option value="De 6 à 7 salariés">De 6 à 7 salariés</option>
					    		<option value="De 8 à 10 salariés">De 8 à 10 salariés</option>
					    		<option value="Plus de 10 salariés">Plus de 10 salariés</option>
								</select>
							</div>
						</div>

					</div>
				</fieldset>

				<h6>Réglement</h6>
				<fieldset>

					<div class="row">
						<div class="col-md-12">

							<label><strong>Statuts et Règlement Intérieur</strong></label>
							<p style="font-size:13px; line-height:18px; text-align:justify;">
								Les informations figurant dans la rubrique « Renseignements administratifs » ci-dessus contiennent des données permettant d’identifier, de façon directe ou indirecte, les titulaires d’officine. Elles sont collectées et traitées, sur la base de votre consentement, par la société OSPHAREA (et ses prestataires techniques) aux fins de gestion de votre adhésion à la coopérative OSPHAREA. Ces informations pourront également être utilisées par OSPHAREA à des fins marketing, telles que l'envoi de communications et d’informations commerciales sur la fourniture de nouveaux services et l’organisation d’évènements. Vos données sont conservées par OSPHAREA pour toute la durée de votre adhésion, augmentée des délais légaux relatifs à la preuve de celle-ci. En application du Règlement européen n°2016/679/UE du 27 avril 2016 relatif à la protection des données personnelles, vous disposez sur vos données des droits (i) d’accès, (ii) de rectification, (iii) d’effacement, (iv) de limitation et (v) de portabilité vers un prestataire tiers le cas échéant. Vous pouvez en toute hypothèse vous opposer à tout moment au traitement de vos données ainsi qu’à l’envoi de nos messages. Vous pourrez faire valoir ces droits en contactant : contact@ospharm.com en justifiant de votre identité. En cas de litige, vous disposez également du droit de saisir la CNIL.<br/> Pour plus d’information sur la protection des données personnelles vous concernant, nous vous invitons à consulter l’article 32- Protection des données à caractère personnel - du Règlement Intérieur.
							</p>
							<div class="form-group">
								<div class="form-check">
									<label class="form-check-label" style="font-size:13px;">
										<input type="checkbox" name="check_1" value="0" class="form-input-styled" data-fouc>
										J'ai pris acte de la note d’information ci-dessus.<span class="text-danger">*</span>
									</label>
								</div>
							</div>
							<div class="form-group">
								<div class="form-check">
									<label class="form-check-label" style="font-size:13px;">
										<input type="checkbox" name="check_1" value="0" class="form-input-styled requiredz" data-fouc>
										 Je reconnais avoir pris connaissance des <a href='#'>statuts</a> et du <a target="_blank"  href='http://www.ospharm.com/wp-content/uploads/2017/08/REGLEMENT_INTERIEUR.pdf'>règlement intérieur</a> d'Ospharea, déclare en accepter les termes et m’engage à le respecter.<span class="text-danger">*</span>
									</label>
								</div>
							</div>
						</div>
					</div>

				</fieldset>

				<h6>Partage</h6>
				<fieldset>

					<div class="row">
						<div class="col-md-12">

							<label><strong>Service Ospharm Datastat</strong></label>
							<p style="font-size:14px; line-height:22px; text-align:justify;">
								Le service OSPharm Datastat permet à tout associé-coopérateur qui souhaite en bénéficier d’accéder aux données statistiques élaborées par la Coopérative OSPHAREA par l’intermédiaire de son extracteur « OSPharm » à partir des données relatives aux actes d’achats et de ventes stockées de l’officine. A aucun moment du processus, une information nominative concernant l’officine est transmise à des tiers excepté à des fins d’anonymisation ou sauf autorisation expresse.
							</p>
							<div class="form-group">
								<div class="form-check">
									<label class="form-check-label" style="font-size:13px;">
										<input type="checkbox" name="check_1" value="0" class="form-input-styled" data-fouc>
										Je déclare vouloir bénéficier du service Ospharm Datastat<span class="text-danger">*</span>
									</label>
								</div>
							</div>
							<div class="form-group">
								<div class="form-check">
									<label class="form-check-label" style="font-size:13px;">
										<input type="checkbox" name="check_1" value="0" class="form-input-styled required" data-fouc>
										 Je m'engage à effectuer les remontées de données chiffrées relatives aux actes d’achat et de vente stockées sur le système informatique de mon officine à la coopérative OSPHAREA, via l’extracteur Ospharm, dans les conditions prévues dans le <a target="_blank"  href='http://www.ospharm.com/wp-content/uploads/2017/08/REGLEMENT_INTERIEUR.pdf'>règlement intérieur</a> d’Ospharea.<span class="text-danger">*</span>
									</label>
								</div>
							</div>
							<div class="form-group">
								<div class="form-check">
									<label class="form-check-label" style="font-size:13px;">
										<input type="checkbox" name="check_1" value="0" class="form-input-styled required" data-fouc>
											J'autorise la coopérative OSPHAREA à utiliser lesdites données pour la création d’études statistiques à destination des associés de la Coopérative ; ces données anonymisées, pourront être transmises à des tiers, dans le cadre et la limite de l’objet social de la coopérative OSPHAREA sur autorisation expresse.<span class="text-danger">*</span>
									</label>
								</div>
							</div>
							<div class="form-group">
								<div class="form-check">
									<label class="form-check-label" style="font-size:13px;">
										<input type="checkbox" name="check_1" value="0" class="form-input-styled required" data-fouc>
											J'autorise Biogaran à utiliser mes prix de ventes pour les produits Biogaran Conseil afin de bénéficier de son service Radar Prix sur Biogaran Pro.<span class="text-danger">*</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</fieldset>

			</form>
		</div>

	</div>

</template>

<script>

// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

// Wizard
var _componentWizard = function() {
		if (!$().steps) {
				console.warn('Warning - steps.min.js is not loaded.');
				return;
		}

		//
		// Wizard with validation
		//

		// Stop function if validation is missing
		if (!$().validate) {
				console.warn('Warning - validate.min.js is not loaded.');
				return;
		}

		// Show form
		var form = $('.steps-validation').show();

		// Initialize wizard
		$('.steps-validation').steps({
				headerTag: 'h6',
				startIndex: 0,
				bodyTag: 'fieldset',
				titleTemplate: '<span class="number">#index#</span> #title#',
				labels: {
						previous: '<i class="icon-arrow-left13 mr-2" /> Précédent',
						next: 'Suivant <i class="icon-arrow-right14 ml-2" />',
						finish: 'Envoyer <i class="icon-arrow-right14 ml-2" />'
				},
				transitionEffect: 'fade',
				autoFocus: true,
				onStepChanging: function (event, currentIndex, newIndex) {

						// Allways allow previous action even if the current form is not valid!
						if (currentIndex > newIndex) {
								return true;
						}

						// Needed in some cases if the user went back (clean up)
						if (currentIndex < newIndex) {

								// To remove error styles
								form.find('.body:eq(' + newIndex + ') label.error').remove();
								form.find('.body:eq(' + newIndex + ') .error').removeClass('error');
						}

						form.validate().settings.ignore = ':disabled,:hidden';
						return form.valid();
				},
				onFinishing: function (event, currentIndex) {
						form.validate().settings.ignore = ':disabled';
						return form.valid();
				},
				onFinished: function (event, currentIndex) {
						window.location.href = process.env.VUE_APP_URL_BIOGARAN;
				}
		});


		// Initialize validation
		$('.steps-validation').validate({
				ignore: 'input[type=hidden], .select2-search__field', // ignore hidden fields
				errorClass: 'validation-invalid-label',
				highlight: function(element, errorClass) {
						$(element).removeClass(errorClass);
				},
				unhighlight: function(element, errorClass) {
						$(element).removeClass(errorClass);
				},

				// Different components require proper error label placement
				errorPlacement: function(error, element) {

						// Unstyled checkboxes, radios
						if (element.parents().hasClass('form-check')) {
								error.appendTo( element.parents('.form-check').parent() );
						}

						// Input with icons and Select2
						else if (element.parents().hasClass('form-group-feedback') || element.hasClass('select2-hidden-accessible')) {
								error.appendTo( element.parent() );
						}

						// Input group, styled file input
						else if (element.parent().is('.uniform-uploader, .uniform-select') || element.parents().hasClass('input-group')) {
								error.appendTo( element.parent().parent() );
						}

						// Other elements
						else {
								error.insertAfter(element);
						}
				},
				rules: {
						email: {
								email: true
						}
				}
		});
};

// Uniform
var _componentUniform = function() {
		if (!$().uniform) {
				console.warn('Warning - uniform.min.js is not loaded.');
				return;
		}

		// Initialize
		$('.form-input-styled').uniform({
				fileButtonClass: 'action btn bg-blue'
		});
};

// Select2 select
var _componentSelect2 = function() {
		if (!$().select2) {
				console.warn('Warning - select2.min.js is not loaded.');
				return;
		}

		// Initialize
		var $select = $('.form-control-select2').select2({
				minimumResultsForSearch: Infinity,
				width: '100%'
		});

		// Trigger value change when selection is made
		$select.on('change', function() {
				$(this).trigger('blur');
		});
};

const axios = require('axios');

export default {
 name: 'home',
 data() {
	 return {
		 name: "test"
	 }
 },
 components: {
   HelloWorld
 },
 mounted: function() {
	 window.App.initBeforeLoad();
	 window.App.initCore();

	 window.App.initAfterLoad();
	 _componentWizard()
	 _componentUniform()
	 _componentSelect2()

	 var self = this;
	 $("#pharma_cip").on('change', function(event) {

			console.log(event.target.value);

			// Make a request for a user with a given ID
			axios.get('http://osp.ph.fr/organization/healthcare-service?cip='+event.target.value)
		  .then(function (response) {
		    // handle success
				response.data.data.name = "Pharmacie "+response.data.data.name;
				for(var k in response.data.data) {
					$("input[name="+k+"]").val(response.data.data[k]);
				}
				self = response.data.data;
		  })
		  .catch(function (error) {
		    // handle error
		    console.log(error);
		  });

	 })

 }
}

</script>
						window.location.href = process.env.VUE_APP_URL_BIOGARAN;


<style type="text/css">

	@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900');

	body {
	  padding: 0px;
    background-color: rgb(245, 245, 245);
	  font-family: sans-serif;
	}
	.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
	  letter-spacing: 0px;
	}
	.ph_register {
	  margin: auto;
		max-width: 900px;
		width: 80%;
	}
	@media (max-width: 768px) {
		.ph_register {
  	  width: 100%;
		}
	}
	.ph_register fieldset {
		min-height: 370px;
	}
	.ph_register .card {
	  width: 100%;
		background: #FFF;
	}
	.ph_register .card-header {
		padding: 0px 15px;
	}
	.ph_register .card-header .h6 {
		padding: 15px 0px;
	}
	.ph_register .header-elements img {
		height: 50px;
		padding: 5px 0px;
		width: auto;
	}
	.ph_register h1 {
		font-weight: 300;
		font-size: 24px;
	}
	.partner-title {
		position: relative;
	}
	.text-ok {
	  background: #95c21e;
	  color: #006841;
	}
	.ph_register .blue {
		background: rgb(243, 251, 255);
	}
	.ph_register .justify {
		text-align: justify;
	}
	.partner-title .col {
	  padding: 5px;
	  margin-top: 8px;
		text-align: center;
		height: 100px;
	}
	.partner-title .col:nth-child(1) img,
	.partner-title .col:nth-child(3) img {
	  margin-top: 0px;
	  height: 100%;
	  width: auto;
	}

</style>
